<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="用户手机号">
                <a-input v-model="queryParam.userPhone" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="操作类型">
                <a-select placeholder="请选择" v-model="queryParam.flowType" style="width: 100%" allow-clear>
                  <a-select-option :value="0">收入</a-select-option>
                  <a-select-option :value="1">支出</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="流水类型">
                <a-select placeholder="请选择" v-model="queryParam.type" style="width: 100%" allow-clear>
                  <a-select-option :value="0">积分</a-select-option>
                  <a-select-option :value="1">余额</a-select-option>
                  <a-select-option :value="2">押金</a-select-option>
                  <a-select-option :value="3">微信</a-select-option>
                  <a-select-option :value="4">支付宝</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="流水来自">
                <a-select placeholder="请选择" v-model="queryParam.fromType" style="width: 100%" allow-clear>
                  <a-select-option :value="0">订单</a-select-option>
                  <a-select-option :value="1">提现</a-select-option>
                  <a-select-option :value="2">充值</a-select-option>
                  <a-select-option :value="3">退款</a-select-option>
                  <a-select-option :value="4">人工</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24" v-if="advanced">
              <a-form-item label="创建时间">
                <a-range-picker
                  v-model="value"
                  format="YYYY-MM-DD"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangeTime"
                />
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 18" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['fund:flowing:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['fund:flowing:export']">
          <a-icon type="download" />导出
        </a-button>
      </div>

      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
      >
        <span slot="flowType" slot-scope="text, record">
          <a-tag :color="record.flowType === 0 ? 'green' : 'red'">
            {{ record.flowType === 0 ? '收入' : '支出' }}
          </a-tag>
        </span>
        <span slot="type" slot-scope="text, record">
          <a-tag :color="getTypeColor(record.type)">
            {{ getTypeText(record.type) }}
          </a-tag>
        </span>
        <span slot="fromType" slot-scope="text, record">
          {{ getFromTypeText(record.fromType) }}
        </span>
        <span slot="flowMoney" slot-scope="text, record">
          <span :style="{ color: record.flowType === 0 ? '#52c41a' : '#f5222d' }">
            {{ record.flowType === 0 ? '+' : '-' }}¥{{ record.flowMoney || 0 }}
          </span>
        </span>
        <span slot="flowBeforeOperationMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="flowAfterOperationMoney" slot-scope="text"> ¥{{ text || 0 }} </span>
        <span slot="flowSerialNo" slot-scope="text, record">
          <a-tooltip :title="record.flowSerialNo || '--'">
            <span class="text-ellipsis">{{ record.flowSerialNo || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          <a-tooltip :title="record.createTime || '--'">
            <span class="text-ellipsis">{{ record.createTime || '--' }}</span>
          </a-tooltip>
        </span>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)" v-hasPermi="['fund:flowing:query']">详情</a>
          <a-divider type="vertical" v-hasPermi="['fund:flowing:query', 'fund:flowing:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['fund:flowing:remove']">删除</a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <detail-drawer ref="detailDrawer" />
  </page-header-wrapper>
</template>

<script>
import { fetchList, delFlowObj } from '@/api/pressure/fund'
import moment from 'moment'
import DetailDrawer from './modules/DetailDrawer.vue'

export default {
  name: 'FundFlow',
  components: {
    DetailDrawer,
  },
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      single: true,
      multiple: true,
      ids: [],
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        userPhone: undefined,
        flowType: undefined,
        type: undefined,
        fromType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      },
      total: 0,
      value: [],
      advanced: false,
      loading: false,
      tableSize: 'default',
      columns: [
        {
          title: '流水号',
          dataIndex: 'flowSerialNo',
          key: 'flowSerialNo',
          scopedSlots: { customRender: 'flowSerialNo' },
          align: 'center',
          width: 180,
        },
        {
          title: '用户手机号',
          dataIndex: 'userPhone',
          key: 'userPhone',
          align: 'center',
          width: 120,
        },
        {
          title: '操作类型',
          dataIndex: 'flowType',
          key: 'flowType',
          scopedSlots: { customRender: 'flowType' },
          align: 'center',
          width: 100,
        },
        {
          title: '流水类型',
          dataIndex: 'type',
          key: 'type',
          scopedSlots: { customRender: 'type' },
          align: 'center',
          width: 100,
        },
        {
          title: '流水来自',
          dataIndex: 'fromType',
          key: 'fromType',
          scopedSlots: { customRender: 'fromType' },
          align: 'center',
          width: 100,
        },
        {
          title: '金额',
          dataIndex: 'flowMoney',
          key: 'flowMoney',
          scopedSlots: { customRender: 'flowMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '操作前金额',
          dataIndex: 'flowBeforeOperationMoney',
          key: 'flowBeforeOperationMoney',
          scopedSlots: { customRender: 'flowBeforeOperationMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '操作后金额',
          dataIndex: 'flowAfterOperationMoney',
          key: 'flowAfterOperationMoney',
          scopedSlots: { customRender: 'flowAfterOperationMoney' },
          align: 'center',
          width: 120,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center',
          width: 180,
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: 120,
        },
      ],
    }
  },
  methods: {
    getTypeText(type) {
      const map = {
        0: '积分',
        1: '余额',
        2: '押金',
        3: '微信',
        4: '支付宝',
      }
      return map[type] || '未知'
    },
    getTypeColor(type) {
      const map = {
        0: 'blue',
        1: 'green',
        2: 'orange',
        3: 'cyan',
        4: 'purple',
      }
      return map[type] || 'gray'
    },
    getFromTypeText(fromType) {
      const map = {
        0: '订单',
        1: '提现',
        2: '充值',
        3: '退款',
        4: '人工',
      }
      return map[fromType] || '未知'
    },
    handleDetail(record) {
      this.$refs.detailDrawer.init(record)
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        userPhone: undefined,
        flowType: undefined,
        type: undefined,
        fromType: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        sortField: undefined,
        sortOrder: undefined,
      }
      this.value = []
      this.handleQuery()
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam)
        .then((res) => {
          this.list = res.data.records || []
          this.total = res.data.total || 0
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    onChangeTime(e) {
      if (e && e.length === 2) {
        this.queryParam.createBeginTime = moment(e[0]).startOf('day').format('YYYY-MM-DD') + ' 00:00:00'
        this.queryParam.createEndTime = moment(e[1]).endOf('day').format('YYYY-MM-DD') + ' 23:59:59'
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      var that = this
      let ids = []
      const postIds = row?.id || this.ids

      if (!postIds || (Array.isArray(postIds) && postIds.length === 0)) {
        this.$message.warning('请选择要删除的数据')
        return
      }

      if (row?.id) {
        ids = [{ id: postIds }]
      } else {
        postIds.forEach((v) => {
          ids.push({ id: v })
        })
      }
      const deleteCount = ids.length
      this.$confirm({
        title: '删除确认',
        content: `确认删除${deleteCount > 1 ? `选中的 ${deleteCount} 条` : '该'}数据吗？删除后将无法恢复。`,
        onOk() {
          return delFlowObj(ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功')
            })
            .catch(() => {})
        },
        onCancel() {},
      })
    },
    handleExport() {
      var that = this
      this.$confirm({
        title: '导出数据',
        content: '确认导出当前筛选条件下的所有数据吗？',
        onOk() {
          that.download(
            'sys/fund/flowing/export',
            {
              ...that.queryParam,
            },
            `资金流水列表_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
  created() {
    this.getList()
  },
}
</script>

<style lang="less" scoped>
.text-ellipsis {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
